<template lang="pug">
div.row.mx-0.h-100
  div.col-3.pl-0
    ul.nav.nav-pills
      li.nav-item(
        v-for="node in mainNodes"
        @click="selectNode(node)"
      )
        a.nav-link(:class="{ active: node.catid == selectedMainNode.catid }")
          | {{ node.label }}
    div.box-list-filter
      ul.list-unstyled.list-origin(
        v-for="catid in Object.keys(tabNodes)"
        v-show="catid == selectedMainNode.catid"
      )
        navigation-index-node-vue(
          v-for="node in tabNodes[catid].nodes"
          :key="node.catid"
          v-bind="node"
          :index="index"
          :selected="selected"
          class="form-check-label pl-0"
          @value-selected="valueSelected"
        )
  .col-9
    breadcrumb-vue(:breadcrumbs="breadcrumbs")
    slot
</template>

<script>
import mixins from 'common/mixins'
import navigation_index_mixin from 'common/mixins/navigation_index'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'navigation-index-main-vue',
  props: {
    index: { type: String, default: '' },
    mainNodes: { type: Array, default: () => [] }
  },
  components: {
    'navigation-index-node-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/navigation_index/Node'
    ),
    'breadcrumb-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/Breadcrumb'
    )
  },
  mixins: [navigation_index_mixin, mixins.filters],
  data: function () {
    return {
      path: [],
      selected: 0,
      selectedMainNode: this.mainNodes[0],
      tabNodes: this.buildTabNodes()
    }
  },
  computed: {
    breadcrumbs() {
      return [this.path]
    }
  },
  methods: {
    async selectNode(node) {
      this.selectedMainNode = node
      this.selected = node.catid
      this.path = [node.label]
      if (!this.tabNodes[this.selectedMainNode.catid].loaded)
        await this.loadChildren()
      this.searchDocuments()
    },
    valueSelected(catid, path) {
      this.path = [this.selectedMainNode.label, ...path]
      this.selected = catid
      this.searchDocuments()
    },
    async loadChildren() {
      this.tabNodes[this.selectedMainNode.catid].nodes =
        await this.retrieveChildren(this.index, this.selectedMainNode.catid)
      this.tabNodes[this.selectedMainNode.catid].loaded = true
    },
    buildTabNodes() {
      return this.mainNodes.reduce((obj, node) => (
        { ...obj, [node.catid]: { nodes: [], loaded: false } }
      ), {})
    },
    searchDocuments() {
      this.setSearchType('general')
      this.setFilters([this.new_filter('clasificaciontotal', [this.selected])])
      this.performSearch()
    },
    ...mapMutations('search', ['setFilters', 'setSearchType']),
    ...mapActions('search', ['performSearch'])
  },
  async created() {
    if (this.mainNodes.length == 0) return

    await this.selectNode(this.mainNodes[0])
  }
}
</script>
